<script setup lang="ts">
import { computed } from "vue";

interface Props {
    disableScroll?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["click"]);

// Compute scroll options for PerfectScrollbar
const scrollOptions = computed(() => ({
    suppressScrollX: props.disableScroll,
    suppressScrollY: props.disableScroll,
}));
</script>
<template>
    <PerfectScrollbar :options="scrollOptions" :class="['Card', { 'scroll-disabled': disableScroll }]" @click="emit('click')">
        <div class="card-content">
            <slot></slot>
        </div>
    </PerfectScrollbar>
</template>
<style lang="scss">
.Card {
    user-select: text;
    overflow: hidden;
    border-radius: 12px;
    margin-bottom: $padding;
    border: 1.5px solid $neutral-200;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    &:last-child {
        margin-bottom: 0;
    }
    .card-content {
        padding: $padding;
        background: $white;
    }

    &.scroll-disabled {
        overflow: unset !important;
        .card-content {
            border-radius: 19px;
        }
        .ps__rail-x,
        .ps__rail-y {
            display: none;
        }
    }

    &.grey {
        .card-content {
            background: $lightgrey3;
        }
    }
}
</style>
